import React from 'react';
import { TPortionSelectionMode } from 'types';
import { portionSelectionModes } from 'appConstants/dishes';
import { Form, Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import Text from 'components/Text/Text';

interface IProps {
	changePortionSelectionMode: (value: TPortionSelectionMode) => void;
	isDisabled: boolean;
}

export const PortionSelectionModeRadio: React.FC<IProps> = React.memo(({ changePortionSelectionMode, isDisabled }) => {
	const handleChange = (event: RadioChangeEvent) => changePortionSelectionMode(event.target.value);

	return (
		<Form.Item className="m-0" name="portionSelectionMode" data-test="PortionSelectionModeRadio">
			<Radio.Group onChange={handleChange} disabled={isDisabled}>
				{portionSelectionModes.map((mode) => (
					<Radio key={mode.id} value={mode.id} data-test={`value-${mode.id}`}>
						<Text translationNameSpace="form" translationKey={mode.name} asFragment={true} />
					</Radio>
				))}
			</Radio.Group>
		</Form.Item>
	);
});
